// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__azoiw","name":"ConsentHeader_name__o3oF_","birthday":"ConsentHeader_birthday__2zesw","skeleton":"ConsentHeader_skeleton__9u5ZP"};